import { createAction, props } from "@ngrx/store";
import { PupilLinkMismatch } from "@core/models/domain/pupil-link.domain";
import { ResolvePupilLinkMismatchRequest } from "@core/models/request/pupil-link.request";

// LOAD PENDING REQUESTS
export const loadMismatches = createAction('[PupilLink] Load Mismatches');
export const loadMismatchesSuccess = createAction(
  '[PupilLink] Load Mismatches Success',
  props<{ mismatches: PupilLinkMismatch[] }>()
);
export const loadMismatchesFailure = createAction(
  '[PupilLink] Load Mismatches Failure',
  props<{ error: any }>()
);

// LINK SELECTED PUPIL
export const resolveMismatch = createAction(
  '[PupilLink] Resolve Mismatch',
  props<{ request: ResolvePupilLinkMismatchRequest }>()
);
export const resolveMismatchSuccess = createAction(
  '[PupilLink] Resolve Mismatch Success',
  props<{ mismatchId: string }>()
);
export const resolveMismatchFailure = createAction(
  '[PupilLink] Resolve Mismatch Failure',
  props<{ mismatchId: string; error: any }>()
);

// CREATE NEW PUPIL (no candidate matches)
export const createPupil = createAction(
  '[PupilLink] Create Pupil',
  props<{ mismatchId: string }>()
);
export const createPupilSuccess = createAction(
  '[PupilLink] Create Pupil Success',
  props<{ mismatchId: string }>()
);
export const createPupilFailure = createAction(
  '[PupilLink] Create Pupil Failure',
  props<{ mismatchId: string; error: any }>()
);

// DISMISS (reject)
export const dismissMismatch = createAction(
  '[PupilLink] Dismiss Mismatch',
  props<{ mismatchId: string }>()
);
export const dismissMismatchSuccess = createAction(
  '[PupilLink] Dismiss Mismatch Success',
  props<{ mismatchId: string }>()
);
export const dismissMismatchFailure = createAction(
  '[PupilLink] Dismiss Mismatch Failure',
  props<{ mismatchId: string; error: any }>()
);
